var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUploadIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 71,
    viewBox: "0 0 81 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.721191,
    width: 81,
    height: 70.184,
    rx: 10,
    fill: "#EBEBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.6981 29.1456C30.0495 28.6548 29.8881 27.7419 30.5368 27.1799L39.2854 18.1958L39.45 18.0532C39.5322 18.0532 39.5322 17.9819 39.6113 17.9819C39.6113 17.9819 39.6936 17.9106 39.7727 17.9106C39.855 17.9106 39.855 17.9106 39.9341 17.8394C40.0163 17.7681 40.0163 17.8393 40.0954 17.7681H41.0637C41.1459 17.7681 41.1459 17.7681 41.225 17.8394C41.3073 17.8394 41.3073 17.8394 41.3864 17.9106C41.3864 17.9106 41.4687 17.9819 41.5478 17.9819C41.63 17.9819 41.63 18.0532 41.7091 18.0532L41.8736 18.1958L50.6223 27.1799C51.1887 27.8104 51.1096 28.6549 50.3787 29.1456C50.056 29.3567 49.7301 29.4965 49.3251 29.4965C48.8378 29.4965 48.4328 29.3567 48.1101 29.0058L42.1174 22.9003V46.974C42.1174 47.7472 41.3896 48.3777 40.4974 48.3777C39.6051 48.3777 38.8774 47.7472 38.8774 46.974L38.8805 22.9003L33.0491 28.9373C32.7264 29.2882 32.2391 29.4281 31.8341 29.4281C31.4291 29.4253 30.9419 29.3568 30.6982 29.1457L30.6981 29.1456ZM56.6181 46.2693C55.7259 46.2693 54.9981 46.8998 54.9981 47.673V50.409C54.9981 50.76 54.6754 51.0396 54.2704 51.0396L26.7304 51.0423C26.3254 51.0423 26.0027 50.7627 26.0027 50.4118V47.6757C26.0027 46.9026 25.275 46.272 24.3827 46.272C23.4904 46.272 22.7627 46.9026 22.7627 47.6757V50.4118C22.7627 52.3062 24.5441 53.8497 26.7304 53.8497H54.1091C56.2955 53.8497 58.0768 52.3062 58.1591 50.4118V47.6757C58.2382 46.9026 57.4281 46.2693 56.6181 46.2693Z",
    fill: "#9E9E9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload_icon.b1e0f2beb06f054f9e0834af10689445.svg";
export { ForwardRef as ReactComponent };